import { defineAsyncActionTypes } from 'store/common/action-helpers';

const prefix = 'graphql/EmsEmployeeProfile';
// FOR ONE GRAPHQL QUERY
export const FETCH_MY_INFO = defineAsyncActionTypes(`${prefix}/FETCH_MY_INFO`);
export const SET_SELECTED_LEARNING_PATH = defineAsyncActionTypes(
  `${prefix}/SET_SELECTED_LEARNING_PATH`
);
